export default __webpack_public_path__ + "482f4d880a7ac7b37de2d042887f71fb.png";